import { Dispatch, FC, useState } from "react";
import {
  Box, FormControl, Grid, InputLabel, Select, Table,
  TableBody, TableContainer, TableHead,TableRow
} from "@mui/material";
import axios, { AxiosInstance } from "axios";
import { StyledTableCell, tableStyle } from "../../content/parametrage/Pays/Pays";
import { urlApi } from "../../content/parametrage/Pays/RowPays";
import { useStyles } from "../styles";
import { LoadingButton } from "@mui/lab";
import { AlertType } from "../../../types/AlertType";
import { AllMounth } from "../../../constants/Constants";
import Paper from "@mui/material/Paper";
import { DeviseInterface } from "../../content/parametrage/Article/InterfaceArticle";
import Cookies from "universal-cookie";
import TauxDechangeFormRow from "./TauxDechangeFormRow";
import { RowToEdit } from "../../content/parametrage/TauxEchange/TauxExchangeRow";
import CheckAttr from "../../../utils/CheckAttr";
import SaveIcon from "@mui/icons-material/Save";

interface TauxDechangeFormProps {
  allDevise: DeviseInterface[];
  row: RowToEdit;
  handleReload: () => void;
  setOpenSnack: Dispatch<React.SetStateAction<boolean>>;
  setAlerteMessage: Dispatch<React.SetStateAction<string>>;
  setAlertType: Dispatch<React.SetStateAction<AlertType>>;
}

const dataYears = [
  new Date().getFullYear(),
  new Date().getFullYear() + 1,
];

const TauxDechangeFormUpdate: FC<TauxDechangeFormProps> = ({
  allDevise,
  row,
  setOpenSnack,
  setAlerteMessage,
  setAlertType,
  handleReload
}) => {
  const classes = useStyles();
  const cookies = new Cookies();
  const token: string = cookies.get("jwt");

  const http: AxiosInstance = axios.create({
    baseURL: urlApi,
    // timeout: 1000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const [isClickSave, setIsClickSave] = useState<boolean>(false);
  const [tauxPerMounth, setTauxPerMounth] = useState<RowToEdit>(row);
  const [errorInput, setErrorInput] = useState<number[]>([]);

  const isValidate = (): boolean => {
    // Reinitialise les variables des validations
    const notValidIndex: number[] = [];
    for (let index = 0; index < tauxPerMounth?.taux?.length; index++) {
      const element = tauxPerMounth?.taux[index];

      !CheckAttr(element?.rate_euro) && notValidIndex.push(index);
    }

    if (CheckAttr(notValidIndex)) {
      setAlerteMessage("Merci de remplir les champs en rouge !");
      setAlertType("warning");
      setOpenSnack(true);

      setErrorInput(notValidIndex);

      return false;
    }

    return true;
  };

  const handleChangeTaux = (value: string, index: number) => {
    let tauxToUpdate = tauxPerMounth?.taux;
    tauxToUpdate[index].rate_euro = value;

    setTauxPerMounth({ ...tauxPerMounth, taux: tauxToUpdate });
  };

  const handleSave = () => {
    setErrorInput([]);
    if (isValidate()) {
      setIsClickSave(true);
      http.put('taux-exchange/update', tauxPerMounth)
        .then((res) => {
          setAlertType("success");
          setAlerteMessage(res.data);
          setOpenSnack(true);
          handleReload();
        }).catch((error) => {
          console.log(error);
        }).finally(() => setIsClickSave(false));
    }
  };

  return (
    <>
      <Grid container spacing={2} columns={{ xs: 6, sm: 12, md: 4 }}>
        <Grid item xs={6} sm={6} md={2}>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            sx={{ marginLeft: 1, marginTop: 1 }}
          >
            <InputLabel
              htmlFor="pays"
              color="warning"
            >
              Année
            </InputLabel>
            <Select
              id="year"
              native
              color="warning"
              disabled
              value={tauxPerMounth?.year}
              label="year"
              inputProps={{
                name: "year",
              }}
            >
              <option value={0}></option>
              {dataYears.map((y) => (
                <option value={y}>{y}</option>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={6} sm={6} md={2}>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            sx={{ marginLeft: 1, marginTop: 1 }}
          >
            <InputLabel
              htmlFor="pays"
              color="warning"
            >
              Mois
            </InputLabel>
            <Select
              id="Mois"
              native
              disabled
              color="warning"
              value={tauxPerMounth?.month}
              label="Mois"
            >
              <option value={0}></option>
              {AllMounth.map((m) => (
                <option value={m.id}>{m.mounth}</option>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <br></br>

      <TableContainer component={Paper} style={tableStyle}>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell align="center">Devise</StyledTableCell>
              <StyledTableCell align="center">Taux Euro</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {allDevise?.slice(1).map((devise, index) => (
              <TauxDechangeFormRow
                key={index}
                index={index}
                rowDevise={devise}
                value={tauxPerMounth?.taux[index]}
                handleChangeTaux={handleChangeTaux}
                errorInput={errorInput}
              />
            )
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Box display="flex" justifyContent="center" mt={5}>
        <LoadingButton
          endIcon={<SaveIcon />}
          loading={isClickSave}
          onClick={() => handleSave()}
          loadingPosition="end"
          sx={{ textTransform: "none" }}
          variant="contained"
          color="warning"
        >
          Enregistrer
        </LoadingButton>
      </Box>
    </>
  );
};

export default TauxDechangeFormUpdate;
